// extracted by mini-css-extract-plugin
module.exports = {"font-size-regular":"15px","fontSizeRegular":"15px","productMoreDescription":"_1gq5p"};